export const businessLogic = {
  cancellationCutOffMinutes: 20,
  returnCutOffDays: 30,
  loyaltyTiers: {
    1: {
      name: "White",
      lowerBound: 0,
      upperBound: 189.99,
    },
    2: {
      name: "Grey",
      lowerBound: 190,
      upperBound: 379.99,
    },
    3: {
      name: "Black",
      lowerBound: 380,
      upperBound: 570,
    },
  },
  lowStockQuantity: 10,
  signupDelaySeconds: 30,
  maxCartTotalQuantity: 6,
  maxCartProductQuantity: 2,
};

export const regionFeatureToggles = {
  gbp: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: false,
  },
  aud: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: false,
  },
  usd: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: false,
  },
  eur: {
    smsStockNotificationsEnabled: false,
    phoneNumberSignUp: false,
    eddEnabled: false,
  },
};

export const klaviyoLists = {
  gbp: {
    accountId: "KKdVHx",
    listId: "PBQpGD",
  },
  aud: {
    accountId: "QLUUqb",
    listId: "LuKxsY",
  },
  usd: {
    accountId: "LvLjjr",
    listId: "N6CnRv",
  },
  eur: {
    accountId: "Q8ECcx",
    listId: "Jxz7Q4",
  },
};

export const localeUrls = {
  gbp: "ratandboa.com",
  aud: "aus.ratandboa.com",
  usd: "us.ratandboa.com",
  eur: "eur.ratandboa.com",
};

export const bannerMessage = {
  gbp: "Up to 70% off",
  aud: "Up to 70% off",
  usd: "Up to 70% off",
  eur: "Up to 70% off",
};

export const signUpBonus = {
  gbp: 20,
  aud: 40,
  usd: 30,
  eur: 20,
};

export const birthdayBonus = {
  gbp: 10,
  aud: 20,
  usd: 15,
  eur: 10,
};

export const shippingRules = {
  gbp: {
    freeForCountry: "GB",
    freeAboveAmount: {
      amount: 200,
      currencyCode: "gbp",
    },
  },
  usd: {
    freeForCountry: "GB",
    freeAboveAmount: {
      amount: 250,
      currencyCode: "usd",
    },
  },
  aud: {
    freeForCountry: "AU",
    freeAboveAmount: null,
  },
  eur: {
    freeForCountry: null,
    freeAboveAmount: {
      amount: 220,
      currencyCode: "eur",
    },
  },
};

export const paymentMethods = {
  gbp: {
    klarnaEnabled: true,
    clearpayEnabled: true,
  },
  usd: {
    klarnaEnabled: false,
    clearpayEnabled: false,
  },
  aud: {
    klarnaEnabled: false,
    clearpayEnabled: true,
  },
  eur: {
    klarnaEnabled: true,
    clearpayEnabled: false,
  },
};

export const orderCutOffForNextDay = {
  gbp: {
    time: "14:00:00",
    timezone: "Europe/London",
  },
  aud: {
    time: "14:00:00",
    timezone: "Australia/Melbourne",
  },
  usd: {
    time: "14:00:00",
    timezone: "Europe/London",
  },
  eur: {
    time: "14:00:00",
    timezone: "Europe/Amsterdam",
  },
};
